import { Navigate, Outlet } from 'react-router-dom'

import { logger } from '@/lib/logger'
import { hasRole } from '@/lib/roles'

import { useAuthStore } from '@/stores/auth'

import { paths } from '@/config/paths'

import type { UserRole } from '../types/user-role'

export default function GuestRoute() {
  const user = useAuthStore((state) => state.user)

  if (user) {
    const allowedRoles: UserRole[] = ['super_admin', 'assistant', 'member']
    const redirectTo = hasRole(user, allowedRoles)
      ? paths.dashboard.root.getHref()
      : paths.public.unauthorized.getHref()

    logger.debug('GuestRoute redirectTo', { redirectTo, roles: user?.roles })
    return <Navigate to={redirectTo} replace />
  }

  logger.debug('GuestRoute guest render')

  return <Outlet />
}
